var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-wrap",on:{"click":_vm.onClick}},[_c('div',{staticClass:"process",style:(`width:${_vm.model}%`)}),_c('div',{staticClass:"total"}),_c('div',{staticClass:"slider",style:(`left:${_vm.model}%`),on:{"touchstart":_vm.onTouchStart,"touchend":_vm.onTouchEnd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }